module.exports = __webpack_public_path__ + "img/KrummeBäume.03956de0.jpg";